export default {
    animation: Boolean | Object,
    culture: String,
    dateInput: Boolean,
    dates: Array,
    format: String,
    interval: Number,
    max: Date,
    min: Date,
    parseFormats: Array,
    value: String | Date,

    // Events
    change: Function,
    close: Function,
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/TimePickerProps.js